import React from 'react';

import { designSystem } from '@/styles/theme';

interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

const HeaderSearchIcon: React.FC<IconProps> = ({ width = 24, height = 24, color = designSystem.colors.primary }) => (
  <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="10.5" cy="10.5" r="7" stroke={color} strokeWidth="1.8" fill="none"/>
    <line x1="15.5" y1="15.5" x2="21" y2="21" stroke={color} strokeWidth="1.8" strokeLinecap="round"/>
  </svg>
);

export default HeaderSearchIcon;
